import { States } from "src/app/enums/States";
import { Ask } from "../Ask/ask.service";
import { Documents } from "../Documents/documents";
import { Field } from "../Field/field";
import { ModulesManagerService } from "../Module/modules-manager.service";
import { Photo } from "@capacitor/camera";

export class DocumentsField extends Field {

    constructor(manager: ModulesManagerService, Data = null) {
        super(manager, Data)
    }

    /** @override */
    async Destroy(): Promise<any> {
    };

    async postRenderHtml(ask: Ask, args: any[]): Promise<any> {
        super.postRenderHtml(ask, args)

        // if (this.AskId > 0)//-- surement a viré mais peut être utilse si on pas tous reçu :/ a voir plus tard
        //     await this.manager.GetModuleData("Documents", 0, "Ask", this.AskId)
    }

    /** @override */
    async onClick(): Promise<any> {
        if (!this.CanEdit) return;
        await this.chooseDocument()
    }

    private documentsPicker() {

        let picker = this.manager.getElementsBy("Id", "documentsPicker" + this.Order)
        if (picker.length) {
            picker[0].click();
        }
    }

    get Value() {
        if (!this.AskId) return []
        return this.manager.GetListModuleData("Documents", "Ask", this.AskId) as Array<Documents>
    }

    // get CanEdit(): boolean {
    //     return this.canEdit && this.hasBypassPermision
    // }

    private isFileExist(fileName) {
        for (const document of this.Value)
            if (document.FileName == fileName) return true
        return false
    }

    async exportValue(): Promise<Array<string>> {
        return await Promise.all(this.Value.map((document) => document.exportData()))
    }

    public async chooseDocument() {
        if (this.manager.Tool.isPlatform("ios") || !this.popup) return this.documentsPicker()
        /*if(this.manager.Tool.isPlatform("ios") && this.manager.Tool.getVersion() !='browser'){
            return this.cameraPicker()
        }*/
        this.manager.Navi.openDocumentPickerPopUp(this.popup, this.documentsPicker.bind(this), this.cameraPicker.bind(this))
    }

    private async cameraPicker() {
        let photo: File = await this.manager.takePicture()
        if (photo) {

            if (!this.isFileExist(photo.name)) {

                let Id: number = this.manager.newId("Documents")// générate new one
                let document: Documents = await this.manager.GetModuleData("Documents", Id)
                await document.StorePictureFromBlob("Ask", this.AskId, photo)
                if (this.AskId > 0) {
                    await document.sendToServer()
                }
            } else {
                this.manager.Tool.notify(this.manager.Trad.Parse("STR_FILE_ALLREADY_EXIST"))
            }
        }
    }

    async onEvent(event): Promise<any> {
        let file = event.target.files[0]
        if (!this.isFileExist(file.name)) {
            let Id: number = this.manager.newId("Documents")// générate new one
            let document: Documents = await this.manager.GetModuleData("Documents", Id)
            await document.StorePictureFromEvent("Ask", this.AskId, event)
            if (this.AskId > 0) {
                await document.sendToServer()
            }
        } else {
            this.manager.Tool.notify(this.manager.Trad.Parse("STR_FILE_ALLREADY_EXIST"))
        }

        // Réinitialiser la valeur de l'input pour permettre la réimportation du même fichier
        event.target.value = '';
    }



}
